// @spec GHG-STR-063
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ExternalExportPage } from '@/features/ghg/exports/components/ExternalExportPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/exports/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.ghgExportForExternalSystems'),
  }),
  component: GHGExportsPage,
});

function GHGExportsPage() {
  return (
    <div className="container mx-auto py-6">
      <ExternalExportPage />
    </div>
  );
}
